// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_76-4";
export var collapsed = "_76-1";
export var headerBar = "_76-0";
export var leftHeaderContent = "_76-3";
export var subjectContainer = "_76-2";